// extracted by mini-css-extract-plugin
export default {"Contacts":"Contacts_Contacts__PlCD+","ContactsMap":"Contacts_ContactsMap__hrv+T"};